import React, { useEffect, useRef } from 'react';
import { type GalleryElement } from '@secretescapes/falcon';
import { useScroll } from '@features/Sale';
import { ModalContainer, StyledModal } from './GalleryModal.styles';
import { ImageGrid } from './ImageGrid';
import { ModalHeader } from './ModalHeader';

interface Props {
  images: GalleryElement[];
  saleId: string;
  saleTitle: string;
  isFavourite: boolean;
  isMobile: boolean;
  modalOpen: boolean;
  onClose: () => void;
  onImageClick: (image: number) => void;
  focusedImageIndex?: number;
}

export const GalleryModal = ({
  images,
  saleId,
  saleTitle,
  isFavourite,
  isMobile,
  modalOpen,
  onClose,
  focusedImageIndex,
  onImageClick,
}: Props) => {
  const modal = useRef<HTMLDivElement | null>(null);
  const modalHeader = useRef<HTMLDivElement | null>(null);
  const focusedImage = useRef<HTMLDivElement | null>(null);
  const { scrollToImage } = useScroll(modalHeader);

  useEffect(() => {
    if (!focusedImageIndex) {
      return;
    }

    scrollToImage(focusedImage, modal);
  }, [focusedImageIndex, scrollToImage]);

  if (!images || !modalOpen) {
    return null;
  }

  return (
    <StyledModal ref={modal} onClose={onClose} isOpen={modalOpen} withCloseButton={false}>
      <ModalContainer>
        <ModalHeader
          ref={modalHeader}
          handleBackClick={onClose}
          saleId={saleId}
          saleTitle={saleTitle}
          isFavourite={isFavourite}
          isMobile={isMobile}
        />
        <ImageGrid
          ref={focusedImage}
          images={images}
          focusedImageIndex={focusedImageIndex}
          onImageClick={onImageClick}
        />
      </ModalContainer>
    </StyledModal>
  );
};
